import { useContext, useState } from 'react';
import { StaticDateRangeSelect } from '@/components/common/date/StaticDateRangeSelect';
import { SingleTargetSelector } from '@/components/common/SingleTargetSelector';
import { ctxTachographDiagram } from '@/contexts/TachographDiagramCtx';
import { MinimalTarget } from '@/generated/model';
import { TabValue } from '@/types';
import { DataMobileView, EmptyView, LoadingView } from './TachographComponents';
import { TachographDataDuringFromToPeriod } from './TachographService';

export function TachographMobileBody({
  tachographProcessedData,
}: {
  tachographProcessedData: TachographDataDuringFromToPeriod[] | undefined;
}) {
  const ctx = useContext(ctxTachographDiagram);
  const [searchText, setSearchText] = useState<string | undefined>(undefined);

  function setSelectedDatesWrapper(from: Date, to: Date) {
    ctx?.setSelectedDates({ from, to });
    ctx?.setTab(TabValue.dateSelect);
  }

  function setSelectedTargetWrapper(target: MinimalTarget | undefined) {
    if (!target) {
      return;
    }
    ctx?.setSelectedTarget(target);
    ctx?.setTab(TabValue.result);
  }

  switch (ctx?.tab) {
    case TabValue.targetSelect:
      return <StaticDateRangeSelect setSelectedDates={setSelectedDatesWrapper} />;
    case TabValue.dateSelect:
      return (
        <SingleTargetSelector
          setSelectedTarget={setSelectedTargetWrapper}
          selectedTarget={ctx.selectedTarget}
          searchText={searchText}
          setSearchText={setSearchText}
          tachographFilter={true}
        />
      );
    case TabValue.result:
      switch (ctx.status) {
        case 'empty':
          return <EmptyView />;
        case 'loading':
          return <LoadingView />;
        case 'data': {
          return <DataMobileView tachographProcessedData={tachographProcessedData} />;
        }
      }
  }
}
